import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-hot",
  "use": "icon-hot-usage",
  "viewBox": "0 0 30 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 16\" id=\"icon-hot\"><defs><style>#icon-hot .cls-1{fill:#ff2020;}#icon-hot .cls-2{fill:#fefefe;}</style></defs><title>资源 27</title><g id=\"icon-hot_图层_2\" data-name=\"图层 2\"><g id=\"icon-hot_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M0,0H24a6,6,0,0,1,6,6V16a0,0,0,0,1,0,0H6a6,6,0,0,1-6-6V0A0,0,0,0,1,0,0Z\" /><path class=\"cls-2\" d=\"M7.7,11.8l.7-3.2h-2l-.8,3.2H3.7L5.6,3.9h2l-.8,3H8.9l.7-3h1.9L9.6,11.8Z\" /><path class=\"cls-2\" d=\"M16.7,10.9a3.4,3.4,0,0,1-2.4.9,2.1,2.1,0,0,1-1.9-.9c-.7-.8-.4-1.9-.1-3.1a5.8,5.8,0,0,1,1.6-3.1,3.8,3.8,0,0,1,2.4-.8,2.5,2.5,0,0,1,2,.8c.6.9.3,2,0,3.1S17.8,10.1,16.7,10.9Zm-.1-5a.8.8,0,0,0-.7-.3,1.2,1.2,0,0,0-.9.3c-.2.2-.4.5-.7,1.9s-.3,1.7-.2,1.9a.7.7,0,0,0,.7.4,1.2,1.2,0,0,0,.8-.4c.2-.2.4-.4.8-1.9S16.7,6.1,16.6,5.9Z\" /><path class=\"cls-2\" d=\"M24,5.6l-1.5,6.2H20.6l1.5-6.2H20.2l.4-1.7h5.8l-.5,1.7Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/hot.svg
// module id = j1mB
// module chunks = 71